<template>
  <transition name="fade">
    <div v-if="visible" :class="[baseCss, app ? 'bcq-app-level' : null]" :is="tag" :style="{zIndex}">
      <div :class="[internalTextColor, internalBgColor, 'text-sm', 'fixed', 'bottom-0', 'left-0', 'right-0', 'p-4', `shadow-${elevation}-up`, rounded ? 'rounded-t-3xl' : null]" :style="{minHeight, zIndex}">
        <slot />
      </div>
      <div v-if="modal" :class="['bcq-bottom-sheets-blocker', 'fixed', 'top-0', 'right-0', 'bottom-0', 'left-0']" />
    </div>
  </transition>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'
import computed from '../../mixins/computed'

export default {
  name: 'BottomSheets',
  mixins: [
    props,
    methods,
    computed
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('bottom-sheets', ['fixed', 'select-none', 'duration-300', 'transition-all'])
    }
  },
  model: {
    prop: 'visible',
    event: 'dismiss'
  },
  props: {
    value: false,
    visible: false,
    rounded: {
      type: Boolean,
      default: true
    },
    modal: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: 'section'
    },
    minHeight: {
      type: String
    },
    app: {
      type: Boolean
    },
    color: {
      type: String,
      default: 'black'
    },
    bgColor: {
      type: String,
      default: 'white'
    },
    zIndex: {
      type: Number,
      default: 2000
    }
  },
  watch: {
    visible () {
      this.$emit('toggle', this.visible)
    }
  }
}
</script>
<style>
.bcq-bottom-sheets-blocker
{
  background: var(--semi-transparent-light);
}

.bcq-ui-theme-dark .bcq-bottom-sheets-blocker
{
  background: var(--semi-transparent-dark);
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/bottom-sheets/bottom-sheets.vue